import { IAction, isType } from '@zaibot/fsa';

import FINGER_TOUCHEND from '../note/finger/actions/TOUCHEND';
import FINGER_TOUCHMOVE from '../note/finger/actions/TOUCHMOVE';
import FINGER_TOUCHSTART from '../note/finger/actions/TOUCHSTART';

interface IState {
    state: string;
    x: number;
    y: number;
}
const emptyState: IState = {
    state: '-',
    x: 0,
    y: 0,
};
export const selector = (state: any) => state.debug as IState;

export const reducer = (state = emptyState, action: IAction) => {
    if (isType(action, FINGER_TOUCHEND)) {
        return { ...state, state: '-' };
    }
    if (isType(action, FINGER_TOUCHMOVE)) {
        const x = action.payload.x;
        const y = action.payload.y;
        return { ...state, x, y };
    }
    if (isType(action, FINGER_TOUCHSTART)) {
        return { ...state, state: 'Selecting' };
    }
    return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/debug/reducer.tsx